export default class TwoPlayersModel {
  constructor() {
    this.playerIcon1 = '';
    this.playerIcon2 = '';
    this.hidingPlayerId = 0;
    this.isReplay = false;
  }

  changeHidingPlayer() {
    this.hidingPlayerId++;
    this.hidingPlayerId %= 2;
  }

  getHidingPlayerIcon() {
    return this.hidingPlayerId === 0 ? this.playerIcon1 : this.playerIcon2;
  }

  getSeekingPlayerIcon() {
    return this.hidingPlayerId === 0 ? this.playerIcon2 : this.playerIcon1;
  }
}
